import type { BaseDialogProps } from '@/shared/ui/DialogKit';
import { BaseDialog } from '@/shared/ui/DialogKit';
import { DialogContent } from '@mui/material';
import Markdown from 'react-markdown';

type Props = BaseDialogProps & {
  text: string;
};

const MarkdownDialog = ({ title, text, ...props }: Props) => {
  return (
    <BaseDialog {...props} title={title} fullWidth maxWidth="lg">
      <DialogContent
        sx={{
          overflowY: 'hidden'
        }}
      >
        <Markdown>{text}</Markdown>
      </DialogContent>
    </BaseDialog>
  );
};

export default MarkdownDialog;
